import cn from 'classnames';
import React from 'react';
import styles from './StatusNotifications.module.scss';
import AppContext from '../AppContext';
import { getTranslateByScope } from '../i18n';
import { getStatusNotification } from '../utils/getStatusNotification';

const translate = getTranslateByScope('app.status');

const Offline = () => (
  <div className={cn(styles.offline)}>{translate('offline')}</div>
);

const UnsyncedOrder = () => (
  <div className={cn(styles.unsyncedOrder)}>
    <div className={cn(styles.unsyncedOrder__title)}>
      {translate('openOrders.title')}
    </div>
    <div>{translate('openOrders.description')}</div>
  </div>
);

const BuildInfo = () => {
  const ref = process.env.REACT_APP_VERSION.substr(0,7);

  return (
    <div className={cn(styles.environment)}>
      <span>{ref}</span>
    </div>
  );
};

export const StatusNotifications = () => (
  <AppContext.Consumer>
    {(context) => {
      const {
        hasNotifications: getStatus,
        isOffline,
        openOrder,
      } = getStatusNotification(context);

      if (!getStatus) {
        return <div />;
      }

      return (
        <div className={cn(styles.statusBar)}>
          {isOffline && <Offline />}
          {openOrder && <UnsyncedOrder />}
          <BuildInfo/>
        </div>
      );
    }}
  </AppContext.Consumer>
);

export default StatusNotifications;
